export interface LibraryConfig {
  env: string;
  apiUrl: string;
  apiKey?: string; // Opcional
  enableDebugMode: boolean;
  // Otros parámetros de configuración que tu librería necesite
}

// Opcionalmente, un InjectionToken para la configuración
import {InjectionToken} from '@angular/core';
export const HOME_LIBRARY_CONFIG = new InjectionToken<LibraryConfig>('home-library.config');
